export const MAX_NOTIFICATION_COUNT = 9;
